import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import reportWebVitals from "./reportWebVitals";

// Import why-did-you-render in development with debug mode
if (
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_DEBUG_RENDERS === "true"
) {
  require("./common/debug/wdyr");
}

const container = document.getElementById("root");
const root = createRoot(container!);
if (container) {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
reportWebVitals();
